import {observer} from "mobx-react";
import React from "react";
import {useStore} from "../../../../../../../hooks";
import {ConfirmationModal as Modal} from "../../../../../../../elements/v2/modals";

export const ConfirmationModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal } = marketingStore;
  
  return (
    <Modal
      isOpen={modal.confirmation}
      title={modal.title}
      message={modal.message}
      icon={modal.icon}
      isExtended={true}
      onConfirm={() => modal.onConfirm("confirmation")}
      onClose={() => modal.onCancel("confirmation")}
      onCancel={() => modal.onCancel("confirmation")}
      onConfirmLabel="Continue"
    />
  );
});
